import styled from 'styled-components';
import MapIcon from '../../../new-components/svg-icons/MapIcon';
import { useTranslation } from 'next-i18next';
import router, { useRouter } from 'next/router';
import { SearchViewTypes } from '../../../new-lib/constants/common';
import { setSearchView } from '../../../redux/slices/mapSlice';
import { logEvent } from '../../../new-lib/analytics';
import { useDispatch, useSelector } from 'react-redux';

const ViewOnMapBtn = () => {
  const { t } = useTranslation('common');
  const dispatch = useDispatch();
  const { locale } = useRouter();
  const isMobile = useSelector((state: any) => state.app.isMobile);
  const handleClick = () => {
    router.push(
      {
        pathname: router.pathname,
        query: { view: SearchViewTypes.MAP }
      },
      undefined,
      { shallow: true }
    );
    dispatch(setSearchView(SearchViewTypes.MAP));
    logEvent.click('search_map_view', 'Search', 'Search');
  };
  return (
    <Container onClick={handleClick} locale={locale} isMobile={isMobile}>
      <MapIcon stroke="#788496" />
      <span className={`map-text `}>{t('map_view')}</span>
    </Container>
  );
};

const Container = styled.button<any>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 8px;
  font-family: materialRegular;
  font-size: 14px;
  background-color: transparent;
  color: #5b6573;
  border: 1px solid #c6d0de;
  border-radius: 12px;
  cursor: pointer;
  height: 100%;
  gap: 8px;

  .map-text {
    position: relative;

    &::after {
      content: ${props => (props.locale === 'ar' ? '"جديد"' : '"New"')};
      position: absolute;
      top: ${props => (props.isMobile ? '-10px' : '-20px')};
      display: flex;
      justify-content: center;
      align-items: center;
      right: ${props =>
        props.locale == 'ar' ? (props.isMobile ? '-38px' : '70px') : 'unset'};
      left: ${props =>
        props.locale == 'en' ? (props.isMobile ? '-35px' : '55px') : 'unset'};
      color: ${props => props.theme.light.colors.white};
      background-color: ${props => props.theme.light.colors.primaryOrange};
      width: ${props => (props.isMobile ? '26px' : '30px')};
      height: ${props => (props.isMobile ? '12px' :  '16px')};
      border-radius: 100px;
      color: #fff;
      font-family: materialRegular;
      font-size: 8px;
      text-transform: capitalize;
    }
  }
`;
export default ViewOnMapBtn;
